import { ITableViewReport } from "../interfaces/table-view";
import authBaseAxios from "../utils/api";
import qs from "qs";

export const ReportServices = {
  
  generateReport: (body: {reports: ITableViewReport[]}): Promise<any> => {
    return authBaseAxios.post(`/financial-report/generate-report`, body);
  },

  getFinancialReportViewId: (viewId: string, params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`/financial-report/${viewId}?${queryString}`);
  },

  exportExcel: (viewId: string, params: any): Promise<Blob> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`financial-report/export/${viewId}?${queryString}`, {
      responseType: "blob",
    });
  },
};
